<template>
    <modal
        :shiftY="0.3"
        :name="name"
        width="69.5%"
        height="auto"
        @before-close="beforeClose"
        :scrollable="true"
        @opened="playVideo"
    >
        <div class="absolute right-0 z-20 pl-4 mt-3 mr-3 transform translate-x-0 md:translate-x-full md:mt-0 md:mr-0">
            <button
                type="button"
                @click="$modal.hide(name)"
                class="flex items-center justify-center w-8 h-8 transition-colors duration-200 bg-white rounded-full hover:text-dark text-gray-2 focus:outline-none focus:shadow-outline"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </div>

        <div class="p-6">
            <video ref="videoElement" class="object-cover w-full h-full" playsinline controls>
                <source :src="video" type="video/mp4">
            </video>
        </div>
    </modal>
</template>

<script>
export default {
    props: ["name", "video"],

    data() {
        return {
            urlHashValue: window.location.hash
        };
    },

    methods: {
        beforeClose() {
            this.$refs.videoElement.pause();
        },
        playVideo() {
            this.$refs.videoElement.play();
        }
    }
};
</script>
